export default __webpack_public_path__ + "static/media/notificationArrow.baef80a6.svg";